import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const RESOURCE_ROLES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('RESOURCE_ROLES');
export const RESOURCE_ROLES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	RESOURCE_ROLES_CRUD_ACTION_CONSTANTS
);
